import * as actionType from "../constants";

const removeChildBoardImage = (id) => (dispatch) => {
  dispatch({ type: actionType.CHILD_BOARD_IMAGE_REMOVE, payload: { id: id } });
};

export default removeChildBoardImage;
